var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"architecture"},[(_vm.detail&&_vm.detail.length)?[_c('div',{staticClass:"archi_content mbj-archi_content",domProps:{"innerHTML":_vm._s(_vm.detail[0].richText)}})]:[_c('nothing')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }